// Default relays - can be overridden by environment variable
// Using reliable, well-maintained relays
export const DEFAULT_RELAYS = [
    'wss://relay.damus.io',
    'wss://nos.lol',
    'wss://relay.snort.social',
    'wss://relay.primal.net',
    // Removed: 'wss://relay.nostr.band' - connection issues
];

// Parse relays from environment variable if provided
const envRelays = import.meta.env.VITE_DEFAULT_RELAYS;
export const RELAYS = envRelays
    ? envRelays.split(',').map((relay: string) => relay.trim())
    : DEFAULT_RELAYS;

// Parse admin pubkeys from environment variable if provided
const envAdminPubkeys = import.meta.env.VITE_ADMIN_PUBKEYS;
const defaultAdminPubkeys = [
    'f3d09e6d9094a665b27af73b69e1f3ee2ea1baa8bd87e8ece149247b628040d5', // User provided admin key
    'bc2c83cc9b280099ce5d147370816873368fd160596af99bc6f65e7132d30aad', // New admin key
];
export const ADMIN_PUBKEYS = envAdminPubkeys
    ? envAdminPubkeys.split(',').map((key: string) => key.trim())
    : defaultAdminPubkeys;

// Relays specifically for moderation lists (read/write) to ensure consistency
// We use a subset of high-quality relays to avoid synchronization issues
export const MODERATION_RELAYS = [
    'wss://relay.damus.io',
    'wss://nos.lol',
    'wss://relay.primal.net'
];

export const WORKER_URL = 'https://mavililer-bot.bluenchanter.workers.dev';
